/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolChangeHistoryIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-change-history"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.1 20.95Q2.3 20.95 1.93 20.26Q1.55 19.57 1.98 18.93L10.88 4.7Q11.28 4.08 12 4.08Q12.72 4.08 13.13 4.7L22.02 18.93Q22.45 19.57 22.07 20.26Q21.7 20.95 20.9 20.95Z" fill={color} />
    </svg>
  );
}
